module.exports = __webpack_public_path__ + "img/testAnalysis_c.c27f68d8.png";